import clsx from "clsx";
import { ComponentPropsWithoutRef, ReactElement } from "react";

export const DialogActions = ({
  className,
  ...props
}: ComponentPropsWithoutRef<"div">): ReactElement => (
  <div
    {...props}
    className={clsx(
      className,
      "mt-8 flex flex-col-reverse items-center justify-end gap-3 *:w-full sm:flex-row sm:*:w-auto",
    )}
  />
);
